import type { ComponentCompilerMeta } from '@stencil/core/internal';
import path from 'node:path';
import { Project, VariableDeclarationKind } from 'ts-morph';
import { kebabToPascalCase } from './utils/string-utils.js';
import type { RenderToStringOptions } from './runtime/ssr.js';

export const createEsModulesComponentsFile = async ({
  components,
  project,
  outDir,
  filename = 'components.ts',
  componentSuffix = '',
  serializeShadowRoot,
}: {
  components: ComponentCompilerMeta[];
  project?: Project;
  outDir?: string;
  filename?: string;
  componentSuffix?: string;
  serializeShadowRoot?: RenderToStringOptions['serializeShadowRoot'];
}) => {
  const tsProject = project || new Project({ useInMemoryFileSystem: true });
  const disableEslint = `/* eslint-disable */\n`;
  const autogeneratedComment = `/**
 * This file was automatically generated by the Stencil React Output Target.
 * Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 */\n\n`;
  const outFile = path.join(outDir || '', filename);
  const sourceFile = tsProject.createSourceFile(outFile, autogeneratedComment + disableEslint, {
    overwrite: true,
  });

  /**
   * Server barrel: emit a single shared `serializeShadowRoot` so consumers
   * don't need to import a per-component file just to get the constant.
   */
  if (componentSuffix) {
    sourceFile.addImportDeclaration({
      moduleSpecifier: '@stencil/react-output-target/ssr',
      namedImports: [{ name: 'SerializeShadowRootOptions', isTypeOnly: true }],
    });
    sourceFile.addVariableStatement({
      isExported: true,
      declarationKind: VariableDeclarationKind.Const,
      declarations: [
        {
          name: 'serializeShadowRoot',
          type: 'SerializeShadowRootOptions',
          initializer: serializeShadowRoot
            ? JSON.stringify(serializeShadowRoot)
            : '{ default: "declarative-shadow-dom" }',
        },
      ],
    });
  }

  for (const component of components) {
    const tagName = component.tagName;
    const reactTagName = kebabToPascalCase(tagName);
    const fileName = component.tagName;
    sourceFile.addExportDeclaration({
      moduleSpecifier: `./${fileName}${componentSuffix}.js`,
      namedExports: [reactTagName],
    });
  }

  sourceFile.organizeImports();
  sourceFile.formatText();
  await sourceFile.save();

  return sourceFile;
};
